import { RawRuleOf } from '@casl/ability';

import { TenantStatusEnum } from '../../../../platform/tenants/enums/tenant-status.enum';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { AppAbility } from '../../authz/types/app-ability';
import { BaseDto } from '../../base/dtos/base.dto';
import { FileDto } from '../../files/dtos/file.dto';
import { UserRoleEnum } from '../enums/user-role.enum';
import { UserStatusEnum } from '../enums/user-status.enum';
import { UserTypeEnum } from '../enums/user-type.enum';

import { UserWatchPreferenceDto } from './user-watch-preference.dto';

/**
 * User DTO for records
 */
@CaslSubject(AppSubjectEnum.USER)
export class UserRecordDto extends BaseDto {
  username!: string;
  authProviderName!: string;
  authProviderUserId!: string;
  email!: string;
  isEmailVerified!: boolean;
  status!: UserStatusEnum;
  notes?: string;
  type!: UserTypeEnum;
  userRoleName!: UserRoleEnum;
  userRolePermissions!: RawRuleOf<AppAbility>[];
  lastLoginAt?: Date;
  lastLoginIp?: string;
  files?: FileDto[];
  watchPreferences?: UserWatchPreferenceDto[];

  /**
   * Session tenant: lowered internal org id (`tenants.tenantId` /
   * `getTenantOrgId()`). Not the numeric PK and not the issued auth-provider
   * org id. Stamped at session hydrate; not stored on the user row.
   */
  tenantOrgId!: string;

  /**
   * Tenant name
   * @description Used to identify the tenant this user belongs to for the purpose of active session.
   * This property is set by the authentication guard and is used to update the request context.
   * It is not stored in the database.
   */
  tenantName!: string;

  /**
   * Current tenant operational status (session-only; from local tenant_metadata).
   */
  tenantStatus?: TenantStatusEnum;

  /**
   * Feature flags enabled for this session (server-eval; not a JWT claim).
   * Tenants that have not started metering receive every known enum slug.
   */
  featureFlags?: string[];
}
